'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigationMenu = require('./NavigationMenu.scss');

var _NavigationMenu2 = _interopRequireDefault(_NavigationMenu);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouterDom = require('react-router-dom');

var _Image = require('../../managewidgets/components/image/Image');

var _Image2 = _interopRequireDefault(_Image);

var _IconPath = require('../../services/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _MobileLayoutHOC = require('../../components/ui/MobileLayoutHOC');

var _MobileLayoutHOC2 = _interopRequireDefault(_MobileLayoutHOC);

var _reactIntl = require('react-intl');

var _Locale = require('../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _ClickTracker = require('../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMenu = function (_React$Component) {
  (0, _inherits3.default)(NavigationMenu, _React$Component);

  function NavigationMenu(props) {
    (0, _classCallCheck3.default)(this, NavigationMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NavigationMenu.__proto__ || (0, _getPrototypeOf2.default)(NavigationMenu)).call(this, props));

    _this.onMenuClicked = function () {
      _this.setState({
        showMenuDropdown: true
      });
    };

    _this.onMenuClosed = function () {
      _this.setState({
        showMenuDropdown: false
      });
    };

    _this.getCachedHandlers = function (route) {
      var cached = _this.cachedHandlers[route.path];

      if (!cached) {
        cached = function cached() {
          if (_this.state.showMenuDropdown) {
            _this.onMenuClosed();
            (0, _ClickTracker.addClickTrack)('mobilenavmenu_' + route.id);
          }

          // do not push to history if trying to go to current route
          if (_this.props.location.pathname === route.path) {
            return;
          }

          if (_this.props.onMenuItemClick) {
            _this.props.onMenuItemClick(route);
          }

          _this.props.history.push(route.path);
        };

        _this.cachedHandlers[route.path] = cached;
      }

      return cached;
    };

    _this.cachedHandlers = {};

    _this.state = {
      showMenuDropdown: false
    };
    return _this;
  }

  (0, _createClass3.default)(NavigationMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        'div',
        { className: _NavigationMenu2.default.wrap },
        _react2.default.createElement(_Image2.default, {
          automationName: 'navmenu_logo',
          className: (0, _classnames2.default)(_NavigationMenu2.default.logo, 'CwThemeFill'),
          src: this.props.logo,
          isInlineSVG: this.props.logoIsInlineSVG,
          onClick: this.props.onLogoClicked
        }),
        this.props.isMobileLayout ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: _NavigationMenu2.default.menu },
            formatMessage(_Locale2.default.menu)
          ),
          _react2.default.createElement(_Image2.default, { automationName: 'mobilenavmenu_menu', className: _NavigationMenu2.default.menuIcon, src: _IconPath2.default.get('Menu'), onClick: this.onMenuClicked })
        ) : _react2.default.createElement(
          'div',
          { className: _NavigationMenu2.default.menuItems },
          this.props.routes.reduce(function (accumulator, route) {
            if (route.showInMenu) {
              var isSelected = _this2.props.location.pathname.split('/')[1] === route.path.split('/')[1];

              accumulator.push(_react2.default.createElement(_Image2.default, {
                key: route.id,
                title: route.name(),
                automationName: 'navmenu_' + route.id,
                className: (0, _classnames2.default)(_NavigationMenu2.default.item, isSelected ? 'CwThemeFill' : _NavigationMenu2.default.itemNotSelected),
                src: _IconPath2.default.get(route.icon),
                onClick: _this2.getCachedHandlers(route) }));
            }

            return accumulator;
          }, [])
        ),
        !this.props.isMobileLayout && this.props.footer ? _react2.default.createElement(
          'div',
          { className: _NavigationMenu2.default.footer },
          this.props.footer
        ) : null,
        this.state.showMenuDropdown ? _react2.default.createElement(
          'div',
          { className: _NavigationMenu2.default.menuDropdown },
          _react2.default.createElement(
            'div',
            { className: _NavigationMenu2.default.menuDropdownHeader },
            _react2.default.createElement(
              'div',
              { className: _NavigationMenu2.default.menuDropdownTitle },
              formatMessage(_Locale2.default.menu)
            ),
            _react2.default.createElement(
              'div',
              { className: _NavigationMenu2.default.menuDropdownClose },
              formatMessage(_Locale2.default.close)
            ),
            _react2.default.createElement(_Image2.default, { automationName: 'mobilenavmenu_close', className: _NavigationMenu2.default.menuDropdownCloseIcon, src: _IconPath2.default.get('Action_Close'), onClick: this.onMenuClosed })
          ),
          this.props.routes.reduce(function (accumulator, route) {
            if (route.showInMenu) {
              accumulator.push(_react2.default.createElement(
                'div',
                { key: route.id, className: _NavigationMenu2.default.menuDropdownItem, onClick: _this2.getCachedHandlers(route) },
                _react2.default.createElement(_Image2.default, { className: _NavigationMenu2.default.menuDropdownItemIcon, src: _IconPath2.default.get(route.icon) }),
                _react2.default.createElement(
                  'div',
                  { className: _NavigationMenu2.default.menuDropdownItemName },
                  route.name()
                )
              ));
            }

            return accumulator;
          }, [])
        ) : null
      );
    }
  }]);
  return NavigationMenu;
}(_react2.default.Component);
//@ts-ignore


NavigationMenu.propTypes = {
  routes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  logo: _propTypes2.default.string.isRequired,
  logoIsInlineSVG: _propTypes2.default.bool,
  onLogoClicked: _propTypes2.default.func,
  footer: _propTypes2.default.element,
  onMenuItemClicked: _propTypes2.default.func
};

exports.default = (0, _reactRouterDom.withRouter)((0, _MobileLayoutHOC2.default)((0, _reactIntl.injectIntl)(NavigationMenu)));


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/navigation/NavigationMenu.js
// module id = 749
// module chunks = 10